import { useState, useEffect, useCallback } from 'react';
import { getJobChargeTotal } from '../api/jobCharges';
import type { ChargeTotal } from '../types/jobCharge';

/**
 * Hook for fetching job charge total
 */
export function useJobChargeTotal(jobId: number | undefined, isForecast?: boolean) {
  const [data, setData] = useState<ChargeTotal | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTotal = useCallback(async () => {
    if (!jobId) {
      setData(null);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const total = await getJobChargeTotal(jobId, isForecast);
      setData(total);
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to fetch charge total');
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [jobId, isForecast]);

  useEffect(() => {
    fetchTotal();
  }, [fetchTotal]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchTotal,
  };
}
